import { EmployeeForSelectFragmentNoAccess } from 'modules/core/components/EntitySelectWrapper/Entities/Employees/types'
import { stringToDate } from 'modules/core/lib/dates'
import i18n from 'modules/core/lib/i18n'

export const validateDate = (startOn: string, endOn: string) => {
  if (stringToDate(endOn, 'backend') <= stringToDate(startOn, 'backend')) {
    return i18n.t('performance_goals.key_results_validations.must_end_later')
  }
}

export const validateTitle = (title: string) => {
  if (title.length === 0) {
    return i18n.t('performance_goals.key_results_validations.title_cant_be_empty')
  }
}

export const validateGoalExistence = (metricGroupId?: string | null) => {
  if (!metricGroupId) {
    return i18n.t('performance_goals.key_results_validations.goal_cant_be_empty')
  }
}

export const validateAssignee = (assigneeId?: number | null) => {
  if (!assigneeId) {
    return i18n.t('performance_goals.key_results_validations.assignee_cant_be_empty')
  }
}

export const validateAssignees = (assignees?: EmployeeForSelectFragmentNoAccess[]) => {
  if (!assignees?.length) {
    return i18n.t('performance_goals.key_results_validations.assignee_cant_be_empty')
  }
}
